import { useEffect } from 'react';
import { brand } from '../app/config';

/**
 * Imposta il titolo della pagina (senza side-effect durante il render).
 */
export function useDocumentTitle(title?: string): void {
    useEffect(() => {
        document.title = title ? `${title} — ${brand.name}` : brand.name;
    }, [title]);
}
